<template>
  <div class="students-section">
    <div class="students-left">
       
      <div class="section-header">
        <p class="section-title"  
        :class="{ active: focusTitSelectId == tit.id }" 
        
          v-for="(tit, index) in focusTit" :key="index"
          @click="selectTab(tit.id)"
         >{{ tit.title }}</p>
        
        <a @click="goNavMore(focusTitSelectId)" class="more-link">MORE+</a>
      </div>
      
      <div class="tab-content">
        <!-- 莘莘学子内容 -->
        <div  class="students-content">
          <div class="content-cards">
            <div class="content-card"  v-for="(item, index) in focusNews.slice(0,3)" :key="index" @click="goDetail(item)">
              <div class="card-image">
                <img :src="item.image" :alt="item.title" />
              </div>
              <div class="card-content">
                <h4 class="card-title">{{ item.title }}</h4>
                <p class="card-description">{{ item.summary }}</p>
              </div>
            </div>
          </div>
        </div>
     
      </div>
    </div>
    <div class="students-right">
        <div class="section-header">
          <p class="section-title">名师风采</p>
          <a @click="goCategoryMore" class="more-link">MORE+</a>
        </div>
        <div class="tu" @click="goArticleDetail">
          <img :src="teacherObj.showPic" alt="">
           <!-- <img src="@/assets/img/special1.jpg" alt=""> -->
        </div>
    </div>
  </div>
</template>

<script>
import { homeApi ,subApi} from '@/api/index'
export default {
  name: 'StudentsSection',
  data() {
    return {
      focusTit:[],
      focusTitSelectId: 1,
      teacherSubNavId:301,
      newsData: {},
      teacherObj:{}
    }
  },
  computed: {
    focusNews() {
      console.log('focusNews',this.newsData[this.focusTitSelectId])
      return this.newsData[this.focusTitSelectId] || [];
    }
  },
  mounted(){
    this.getArticleList();
    this.getTeacherData();
  },
  methods:{
       //获取焦点新闻等文章列表数据
    async getArticleList(){
      try {
        let params = {
          categoryIds:'7,8',
          count:7
        }
        
        const response = await homeApi.getArticleList(params)
      
        if (response && response.code === 0) {
          
          let data = response.data;
          this.focusTitSelectId = data[0].id;
          console.log(this.focusTitSelectId,'focusTitSelectId')
          data.forEach(list => {
            this.focusTit.push({
              title:list.title,
              id:list.id
            })
            
            this.newsData[list.id] = []
            list.subList.forEach(sub =>{
             sub.items.forEach(items=>{
           
             
                this.newsData[list.id].push({
                  title:items.title,
                  date:items.datetime,
                  image:items.image,
                  summary:items.summary,
                  id:items.id
                })
             })
            })
          });

          console.log(this.newsData,'newsData')

          
        } else {
         
          this.newsData = [];
        }
      } catch (error) {
       // console.error('获取轮播图数据异常:', error)
      }
    },
     //获取名师风采数据
  async  getTeacherData() {
    

       try {
        let params = {
          categoryId:this.teacherSubNavId,
          pageNo:1,
          pageSize:1
        }
        
        const response = await subApi.getSubArticleList(params)
      
        if (response && response.code === 0) {
         this.teacherObj = {
            showPic:response.data.list[0].image,
            title:response.data.list[0].title,
            articleId:response.data.list[0].articleId
         }
          
        
        } else {
          console.error('获取名师风采数据失败:', response)
         
        }
      } catch (error) {
        console.error('获取名师风采数据异常:', error)
      }
     
    },
    selectTab(tabId) {
      this.focusTitSelectId = tabId;
    
    },
    goNavMore(id){
      this.$router.push({
        path:'/category',
        query:{
          id:id
        }
      })
    },
     goDetail(item){
   
      
      this.$router.push({
        path:'/article',
        query:{
          id:item.id
        }
      })
    },
    //跳转到名师风采二级页面
    goCategoryMore(){
      this.$router.push({
        path: '/categoryMore',
        query: {
          categoryId: 3,
          sectionId:this.teacherSubNavId,
          categoryTitle: '师资队伍',
          sectionTitle: this.teacherObj.title
        }
      })
    },
    goArticleDetail(){
      this.$router.push({
        path:'/article',
        query:{
          id:this.teacherObj.articleId
        }
      })
    }
  }
}
</script>

<style scoped>
.students-section {

  
  overflow: hidden;

  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 30px;
}
.students-left{
  width: 800px;
   box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  background: #fff;
  border-radius: 8px;

  .section-header {
     border-top:1px solid #1dc2b7;
  }
}
.students-right{
  width: 320px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
    border-radius: 8px;
  .section-header {
     border-top:1px solid #899d63;
     .section-title{
        background: #899d63 !important;
        color: #fff;
     }
  }
  .tu{
    width: 300px;
    height: 230px;
    margin:30px 10px;
    cursor: pointer;
    img{
      display: block;
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
}
.active{
  background: #1dc2b7 !important;
  color: #fff;
}
.section-title:hover{
   background: #1dc2b7 !important;
  color: #fff;
}
.section-header {
  display: flex;
  color: #333;
  position: relative;
  .section-title{
  
    font-size: 16px;
    margin-right: 6px;
    padding: 12px 16px;
    background: #eee;
    cursor: pointer;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }
}

.more-link {
  color: #333;
  text-decoration: none;
  font-size:12px;
  padding: 12px 16px;
  position: absolute;
  right: 0;
  top: 0;
  cursor: pointer;
}

.tab-buttons {
  display: flex;
  gap: 0;
}

.tab-button {
  background: none;
  border: none;
  color: white;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px 4px 0 0;
  transition: all 0.3s ease;
  position: relative;
}

.tab-button:hover {
  background: rgba(255, 255, 255, 0.1);
}

.tab-button.active {
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
}

.tab-button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 3px;
  background: #ffd700;
}

.tab-content {
  padding: 20px;
  
}

.students-content,
.technology-content {
  display: flex;
  flex-direction: column;
}

/* 卡片容器 */
.content-cards {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

/* 单个卡片 */
.content-card {
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  cursor: pointer;
}

.content-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
}

/* 卡片图片 */
.card-image {
  width: 100%;
  height: 200px;
  overflow: hidden;
}

.card-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.content-card:hover .card-image img {
  transform: scale(1.05);
}

/* 卡片内容 */
.card-content {
  padding: 15px;
}

.card-title {
  font-size: 14px;
  color: #333;
  margin: 0 0 8px 0;
  font-weight: 600;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.card-description {
  font-size: 12px;
  color: #666;
  margin: 0;
  line-height: 1.4;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .students-section {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .students-left {
    width: 100%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: #fff;
  }
  
  .content-cards {
    grid-template-columns: repeat(2, 1fr);
    gap: 15px;
  }
  
  .card-image {
    height: 150px;
  }
  
  .card-title {
    font-size: 13px;
  }
  
  .card-description {
    font-size: 11px;
  }
}

@media (max-width: 480px) {
  .tab-content {
    padding: 15px;
  }
  
  .content-cards {
    grid-template-columns: 1fr;
    gap: 15px;
  }
  
  .card-image {
    height: 180px;
  }
  
  .card-content {
    padding: 12px;
  }
  
  .card-title {
    font-size: 12px;
  }
  
  .card-description {
    font-size: 10px;
  }
}
</style>

